<template>
  <div class="carousel" :style="{ width: '100%', height: '600px' }">
    <el-carousel height="600px">
      <el-carousel-item v-for="(item, index) in images" :key="index">
        <img :src="item" style="width: 100%; height: 100%; object-fit: cover" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require('../assets/img/lunbo1.png'),
        require('../assets/img/lunbo2.png'),
      ].filter(Boolean), // 过滤掉不存在的图片
    };
  },
  mounted() {},
  beforeUnmount() {},
  methods: {},
};
</script>

<style scoped></style>
